<template>
  <div
    class="d-flex align-items-center justify-content-center text-center bg-light"
    style="width: 100%; height: 100vh;"
  >
    <div class="w-50">
      <div class="container">
        <h1>RAINN Speakers Bureau Login</h1>
        <hr class="my-4" />
        <div style="max-width: 50%; margin-left: 25%;">
          <div class="input-group">
            <input
              type="email"
              :class="
                `form-control ${
                  missingInformation && email.length === 0
                    ? 'border-danger'
                    : ''
                }`
              "
              placeholder="Email Address"
              :value="email"
              @keyup="e => (this.email = e.target.value)"
              @keyup.enter="() => login()"
            />
          </div>
          <div class="input-group mt-2">
            <input
              type="password"
              :class="
                `form-control ${
                  missingInformation && password.length === 0
                    ? 'border-danger'
                    : ''
                }`
              "
              placeholder="Password"
              :value="password"
              @keyup="e => (this.password = e.target.value)"
              @keyup.enter="() => login()"
            />
          </div>
        </div>
        <button
          class="btn btn-primary btn-sm mt-3"
          type="button"
          style="width: 33%;"
          @click="() => login()"
        >
          Submit
        </button>
        <br />
        <button
          class="btn btn-link mt-2"
          type="button"
          @click="() => sendPasswordResetEmail()"
        >
          Reset/Forgot Password
        </button>
        <div v-if="error.length" class="alert alert-danger mt-2" role="alert">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data: () => {
    return {
      email: "",
      password: "",
      missingInformation: false,
      incorrectInformation: false,
      error: ""
    };
  },
  methods: {
    async login() {
      this.missingInformation = false;
      this.error = "";
      if (this.email.length === 0 || this.password.length === 0) {
        this.missingInformation = true;
        this.$swal({
          title: "Missing information!",
          type: "error",
          text: "You must provide an email address and password!"
        });
      } else {
        try {
          await this.$store.dispatch("auth/login", {
            email: this.email,
            password: this.password
          });
          if (this.$store.getters["auth/isSpeaker"]) {
            this.$router.push("/applications/mine");
          } else if (this.$store.getters["auth/isStaffer"]) {
            this.$router.push("/search");
          } else {
            this.$store.dispatch("auth/logout");
            this.$swal({
              title: "Unable to login!",
              text: "You do not have valid permissions.",
              type: "error"
            });
          }
        } catch (err) {
          if (err && err.code) {
            switch (err.code) {
              case "auth/network-request-failed":
                this.error = "Unable to connect to the internet!";
                break;
              case "auth/invalid-email":
              case "auth/user-disabled":
              case "auth/user-not-found":
              case "auth/wrong-password":
                this.error =
                  "The provide email address and/or the provided password are incorrect.";
                break;
              default:
                this.error = "An unexpected error occurred!";
                break;
            }
          }
        }
      }
    },
    async sendPasswordResetEmail() {
      try {
        const result = await this.$swal({
          title: "Send Password Reset Email",
          type: "info",
          input: "email",
          inputPlaceholder: "Email Address",
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: async value => {
            try {
              await this.$store.dispatch("auth/resetPassword", {
                email: value
              });
            } catch (err) {
              switch (err.code) {
                case "auth/user-not-found":
                  // Do not indicate error to user
                  this.$swal({
                    title: "Password Reset Email Sent!",
                    type: "success"
                  });
                  break;
                default:
                  this.$swal({
                    title: "An unexpected error occurred!",
                    type: "error",
                    text: "A password reset email was unable to be sent."
                  });
                  break;
              }
            }
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          inputValidator: inputValue => {
            if (inputValue.length === 0) {
              return "You must provide an email address!";
            }
          }
        });
        if (result.dismiss !== "cancel") {
          this.$swal({
            title: "Password Reset Email Sent!",
            type: "success"
          });
        }
      } catch {
        this.$swal({
          title: "An unexpected error occurred!",
          type: "error",
          text: "A password reset email was unable to be sent."
        });
      }
    }
  }
};
</script>

<style></style>
